/**
 * Core / Plugin: Directives
 * -----------------------------------------------------------------------------
 * Vue plugin to extend Vue instance with global directives.
 * - Add in alphabetical order.
 *
 */

export default {
  install: (app) => {

    /**
     * Sets a `v-click-outside` directive to detect click outside events.
     * - Usage: Add `v-click-outside` to an element and pass in an event handler
     * - e.g. `v-click-outside="hideElement"`.
     */
    app.directive('click-outside', {
      beforeMount(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    })
  },
}
